/**
 * Site-wide interaction lock — set while Pixel's full-charge short plays,
 * so the page can't be scrolled or clicked until he's done.
 */
let locked = false;
const listeners = new Set<() => void>();

export function setInteractionLock(value: boolean) {
  if (value === locked) return;
  locked = value;
  listeners.forEach((l) => l());
}

export function isInteractionLocked() {
  return locked;
}

export function subscribeInteractionLock(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
